var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5093 18.1963L4.58803 18.7541L4.01367 20.692C6.14685 22.8251 8.98304 24 11.9998 24L12.7057 22.1658L11.9998 20.4705L6.5093 18.1963Z",
    fill: "#404A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01303 4.71973C1.8799 6.8529 0.705078 9.68909 0.705078 12.7058L2.5639 13.0364L4.23449 12.7058L6.5087 7.2154L5.78743 5.59996L4.01303 4.71973Z",
    fill: "#404A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7644 12.7057L17.4902 18.1962L18.3527 20.109L19.9859 20.6918C22.119 18.5587 23.2939 15.7225 23.2939 12.7057L21.435 11.7422L19.7644 12.7057Z",
    fill: "#283366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9846 4.71966C18.3392 3.07416 16.2754 1.999 14.0331 1.59326L12.6338 2.78813L12.291 5.0622L17.489 7.21533L19.175 6.30578L19.9846 4.71966Z",
    fill: "#283366"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9859 4.71973L17.4902 7.2154L19.7644 12.7058H23.2939C23.2939 9.68909 22.119 6.8529 19.9859 4.71973Z",
    fill: "#FF3377"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4905 18.1963L12 20.4705V24C15.0168 24 17.8529 22.8251 19.9861 20.692L17.4905 18.1963Z",
    fill: "#FF3377"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23449 12.7061H0.705078C0.705078 15.7229 1.8799 18.559 4.01303 20.6922L6.5087 18.1965L4.23449 12.7061Z",
    fill: "#FF6C6C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99033 1.58887C7.73838 1.99103 5.6653 3.06811 4.01367 4.71974L6.50934 7.21541L11.7231 5.05578L11.3175 2.91762L9.99033 1.58887Z",
    fill: "#FF6C6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23438 12.7061C4.23438 16.9944 7.71075 20.4708 11.9991 20.4708L12.705 12.7061L11.9991 4.94141C7.71075 4.94141 4.23438 8.41778 4.23438 12.7061Z",
    fill: "#FFF5F5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.94141V20.4708C16.2883 20.4708 19.7647 16.9944 19.7647 12.7061C19.7647 8.41778 16.2883 4.94141 12 4.94141Z",
    fill: "#ECE6F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0874 10.7952L9.50412 9.21191L8.50586 10.2102L10.0892 11.7935C9.81508 12.3689 9.81508 13.0429 10.0892 13.6183L8.50586 15.2016L9.50412 16.1998L11.0874 14.6165C11.3751 14.7536 11.6874 14.8225 11.9998 14.8225L12.7057 12.7059L11.9998 10.5897C11.6875 10.5897 11.3751 10.6582 11.0874 10.7952Z",
    fill: "#404A80"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9107 11.7935L15.494 10.2102L14.4957 9.21191L12.9124 10.7952C12.6248 10.6582 12.3124 10.5897 12 10.5897V14.8225C12.3124 14.8225 12.6247 14.7536 12.9124 14.6165L14.4957 16.1998L15.494 15.2016L13.9107 13.6183C14.1847 13.0429 14.1847 12.3689 13.9107 11.7935Z",
    fill: "#283366"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17578 0L11.9993 5.64706L12.7052 2.11765L11.9993 0H9.17578Z",
    fill: "#FFDD00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V5.64706L14.8235 0H12Z",
    fill: "#FFC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/Live.7eb3bc6ec1bd50adbbf7d886c626dff4.svg";
export { ForwardRef as ReactComponent };